<template>
  <div>
    <search-area tabName="广场订单列表" @search="search(1)">
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="订单状态" prop="status" :label-width="105">
          <Select
            v-model="searchParam.status"
            style="width: 160px"
            @on-change="search(1)"
            clearable
          >
            <Option
              v-for="item in stateList"
              :value="item.code"
              :key="item.code"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="orderList"
      :total="total"
      @search="search"
      :pageNum="searchParam.currentPage"
      :pageSize="searchParam.pageSize"
    ></table-area>
    <el-dialog title="填写派单信息" :visible.sync="showDispatch">
      <el-form :model="form" ref="formName" :rules="rule">
        <el-form-item label="选择商家" label-width="100" prop="companyId">
          <el-select
            :disabled="isCompany"
            v-model="form.companyId"
            placeholder="请选择商家"
            @change="handleSelectChange"
          >
            <el-option
              v-for="item in companyList"
              v-bind:key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择保洁员" label-width="100" prop="serviceUserId">
          <el-select v-model="form.serviceUserId" placeholder="请选择保洁员">
            <el-option
              v-for="item in cleanerList"
              v-bind:key="item.id"
              :label="item.realName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDispatch = false">取 消</el-button>
        <el-button type="primary" @click="onConfirmTransfer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import columns from "./column-config-square";
export default {
  data() {
    return {
      columns: columns(this),
      // 列表数据总数
      total: 0,
      // 加载中
      loading: false,
      // 搜索参数
      searchParam: {
        page: 1,
        pageSize: 10,
        status: "",
      },
      orderList: [],
      stateList: [
        { value: "待付款", code: "1" },
        { value: "待开始", code: "2" },
        { value: "进行中", code: "3" },
        { value: "已完成", code: "4" },
      ],
      showDispatch: false,
      isCompany: window.userInfo.companyId ? true : false,
      form: {
        companyId: window.userInfo.companyId || "",
        serviceUserId: "",
        id: "",
      },
      companyList: [],
      cleanerList: [],
      rule: {
        companyId: [
          { required: true, message: "请选择商家", trigger: "change" },
        ],
        serviceUserId: [
          { required: true, message: "请选择保洁员", trigger: "change" },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getOrderList();
    this.getCompanyList();
    if (this.isCompany) {
      this.getCleanerList();
    }
  },
  methods: {
    // 执行搜索
    search(val) {
      this.searchParam.page = val;
      this.getOrderList();
    },
    async getOrderList() {
      const res = await this.$post(
        "/customerService/listByPageAdmin",
        this.searchParam
      );
      this.orderList = res.list || [];
      this.total = res.total || 0;
    },
    // 管理员取消订单
    handleCancelOrder(id) {
      this.$confirm(`确认取消订单 ${id}？`, "取消订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$post("/customerService/adminCancel", { id });
          this.$message({ type: "success", message: "订单已取消" });
          this.getOrderList();
        })
        .catch(() => {});
    },
    // 管理员转单
    handleTransferOrder(id) {
      this.form.id = id;
      this.showDispatch = true;
    },
    async onConfirmTransfer() {
      this.$refs.formName.validate(async (valid) => {
        if (valid) {
          await this.$post("/customerService/transferCustomerService", {
            id: this.form.id,
            acceptUserId: this.form.serviceUserId,
          });
          this.$message.success("操作成功");
          this.showDispatch = false;
          this.getOrderList();
        }
      });
    },
    async getCompanyList() {
      let list = await this.$get("/company/all");
      this.companyList = list || [];
    },
    async getCleanerList(id) {
      let res = await this.$post("/company/cleanerListByPage", {
        companyId: id || window.userInfo.companyId,
        currentPage: 1,
        nowStatus: "2",
        pageSize: 999,
      });
      this.cleanerList = res.list || [];
      this.form.serviceUserId = "";
    },
    handleSelectChange(val) {
      this.getCleanerList(val);
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped>
@import './../../styl/variables.styl'
@import './../../styl/common.styl'

.tableOut
    height: 50px;
    border: 0.1px solid #e0dede;
    background: #f1f4f512;
    span
      width: 20%;
      text-align: center;
      display: inline-block;
      float: left;
      font-size: 17px;
      border-right: 1px solid #e0dede;
      height: 50px;
      line-height: 50px;
      box-sizing: border-box;

.huiline
    padding:10px;
    border: 1px solid #e0dede;
    box-sizing: border-box;
    width: 100%;
    border-top: 0;
    background: #f1f4f512;
    font-size: 13px;
    color: #b3b0b0;

    span
     margin-left 40px
.payitem
    display: flex;
    flex-direction: column;
    text-align: left;
    box-sizing: border-box;
    padding-left: 50px;

.details
    display: flex;
    justify-content: space-around;
    font-size: 13px;
    border-bottom: 1px solid #e0dede;
    border-right: 1px solid #e0dede;

  .divspp
    width:20%;
    border-left: 1px solid #e0dede;
    padding: 10px 0;
    box-sizing:border-box;
    display: flex;
    flex-direction: column;
    align-items:center;
    text-align: left;
    box-sizing: border-box;
    justify-content: center;
.picker
    margin-left 10px

.filter-search
  display flex
  flex-wrap wrap

  .el-date-editor
    max-width 360px
    margin-right 10px
    margin-bottom 10px

  .el-input
    max-width 140px
    margin-right 10px
    margin-bottom 10px

.option-button
  position relative
  padding-right 50px

  .edit-btn
    position absolute
    right 4px

.form-upload-excel
  display inline-block
  margin-left 10px

.table-container
  margin-top 20px

  .el-pagination
    margin-top 20px

  .preview
    display flex
    justify-content center
    align-items center
    padding 10px
    margin-top 6px
    border 1px dashed #999
    border-radius 6px
  .el-dialog
    width: 500px;
.Dealing{
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100px;
}
.wildFinished{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  .DealFinished{
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: normal;
    width: 200px;
  }
  .DealFinishedfoot{
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}
.direct-mail{
  color: #7600FF;
  border: 1px solid #7600FF;
  padding: 2px;
  margin-right: 2px;
  border-radius: 4px;
  font-size: 12px;
}
</style>
